/**
 * Client-side phone number check.
 *
 * Deliberately mirrors app/validators/phone_number_validator.rb: strip the
 * punctuation people actually type, then require 10-15 digits. Keep the two in
 * step -- if they disagree, the form either rejects something the server would
 * accept, or lets through something the server bounces with a less friendly
 * message.
 *
 * This is a convenience check only. PhoneNumberValidator on the User model is
 * the one that decides, and it runs on every path whether or not this code did.
 */

const MIN_DIGITS = 10;
const MAX_DIGITS = 15;

// Whitespace, brackets, dots, hyphens (including en/em dashes) and slashes.
const DECORATION = /[\s().\-\u2013\u2014/]/g;

/**
 * @param {string} value
 * @returns {boolean}
 */
export function isValidPhoneNumber(value) {
  if (!value) {
    return false;
  }

  const stripped = String(value).replace(DECORATION, '').replace(/^\+/, '');

  if (!/^\d+$/.test(stripped)) {
    return false;
  }

  return stripped.length >= MIN_DIGITS && stripped.length <= MAX_DIGITS;
}
